<template>
  <div class="user-box">
    <ul class="select-option">
      <li>
        <el-input
          v-model="roleName"
          placeholder="请输入角色名称"
          class="select-input"
          @keyup.enter.native="search"
        />
      </li>
      <li>
        <el-button type="primary" icon="el-icon-search" @click.stop="search">
          查询
        </el-button>
      </li>
      <li v-if="checkPermission('sys:role:save', permList)">
        <el-button type="primary" icon="iconfont icon-plus" @click.stop="add">
          增加
        </el-button>
      </li>
      <li v-if="checkPermission('sys:role:save', permList)">
        <el-button type="primary" icon="iconfont icon-xiugai" @click.stop="revise">
          修改
        </el-button>
      </li>
      <li v-if="checkPermission('sys:role:save', permList)">
        <el-button type="primary" icon="iconfont icon-delet" @click.stop="del">
          删除
        </el-button>
      </li>
    </ul>

    <el-table
      ref="multipleTable"
      :data="tableData.records"
      border
      tooltip-effect="dark"
      style="width: 100%"
      :row-style="rowStyle"
      :row-class-name="rowClassName"
      @selection-change="selectionChange"
      @row-click="rowClick"
    >
      <el-table-column
        label="序号"
        type="index"
        :index="indexMethod"
        width="50"
        align="center"
      />
      <el-table-column type="selection" width="50" align="center" />
      <el-table-column label="角色ID" prop="roleId" width="80" align="center" />
      <el-table-column width="200" prop="roleName" label="角色名称" />
      <el-table-column
        width="200"
        prop="deptName"
        label="所属部门"
        show-overflow-tooltip
      />
      <el-table-column prop="remark" label="备注" show-overflow-tooltip />
      <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip />
    </el-table>
    <div style="text-align: center; margin-top: 25px">
      <el-pagination
        :page-size="tableData.size"
        :current-page="pageIndex"
        background
        layout="total,prev, pager, next, jumper"
        :total="tableData.total"
        @current-change="pageChange"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {

  data() {
    return {
      loading: false,
      limit: 10,
      pageIndex: 1,
      roleName: '',
      tableData: {},
      selectRows: []
    }
  },

  computed: {
    ...mapState({
      permList: (state) => state.permission.permList
    }),

    selectRowsId() {
      const idArr = []
      if (this.selectRows.length > 0) {
        this.selectRows.filter((item) => {
          idArr.push(item.roleId)
        })
      }
      return idArr
    }
  },

  created() {
    this.$emit('setCurrentMenu', '角色管理')
    this.getUserList(this.limit, this.pageIndex, this.roleName)
  },

  methods: {
    indexMethod(index) {
      return (this.pageIndex - 1) * this.limit + index + 1
    },

    getUserList(limit, pageIndex, roleName) {
      const vm = this
      vm.axios
        .get(this.homePath() + '/sys/role/list', {
          params: {
            limit: limit,
            page: pageIndex,
            roleName: roleName
          }
        })
        .then((response) => {
          const data = response.data
          if (data.status == '000000') {
            vm.tableData = data.page
          } else if (data.status == '100000') {
            this.$alert(data.message, '提示', {
              confirmButtonText: '确定',
              callback() {
                vm.$router.push('/index/role')
              }
            })
          }
        })
        .catch((error) => console.log(error))
    },

    search() {
      this.getUserList(this.limit, this.pageIndex, this.roleName)
    },

    add() {
      this.$router.push('/index/addrole')
    },

    revise() {
      const vm = this
      if (vm.selectRows.length < 1) {
        vm.$alert('请选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })

        return
      }

      if (vm.selectRows.length > 1) {
        vm.$alert('只能选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })

        return
      }

      this.$router.push('/index/reviserole/' + vm.selectRows[0].roleId)
    },
    del() {
      const vm = this
      vm.$confirm('确定要删除选中的记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          vm.axios
            .post(vm.homePath() + '/sys/role/delete', vm.selectRowsId)
            .then((response) => {
              if (response.data.status == '000000') {
                vm.$message({
                  type: 'success',
                  message: '删除成功!'
                })

                vm.getUserList(vm.limit, vm.pageIndex, vm.username)
              } else {
                console.log(response.data.message)
              }
            })
            .catch((error) => console.log(error))
        })
        .catch(() => {
          vm.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },

    rowClick(row, column, event) {
      const refsElTable = this.$refs.multipleTable
      const findRow = this.selectRows.find((c) => c.rowIndex == row.rowIndex)
      if (findRow) {
        refsElTable.toggleRowSelection(row, false)
        return
      }
      refsElTable.clearSelection()
      refsElTable.toggleRowSelection(row)
    },

    rowStyle({ row, rowIndex }) {
      Object.defineProperty(row, 'rowIndex', {
        value: rowIndex,
        writable: true,
        enumerable: false
      })
    },

    rowClassName({ row, rowIndex }) {
      let rowName = ''
      const findRow = this.selectRows.find((c) => c.rowIndex === row.rowIndex)
      if (findRow) {
        rowName = 'current-row '
      }
      return rowName
    },

    selectionChange(rows) {
      this.selectRows = rows
    },

    pageChange(val) {
      this.pageIndex = val
      this.getUserList(this.limit, this.pageIndex, this.username)
    }
  }
}
</script>
